module.exports = __webpack_public_path__ + "static/max-festa-05183af82de6b39737beddc99c15bb32.jpg";